import type { ElementWithOptionalImageType } from '../../../types'
import type { ButtonComponentType } from '../../button'
import type { ModalSheetProps } from '../modal-sheet'

type ModalDialogPropsBase = ModalSheetProps & {
  body?: string
  cancelButton: ButtonComponentType
  confirmButton: ButtonComponentType
  subtitle?: string
  title: string
  variant: ModalDialogVariantType
}

export type ModalDialogProps = ElementWithOptionalImageType<ModalDialogPropsBase>

export enum ModalDialogVariant {
  confirmation = 'confirmation',
  destructive = 'destructive',
}

export type ModalDialogVariantType = `${ModalDialogVariant}`
